export const RENT_TYPE = {
  ENTIRE_PROPERTY: 'property',
  BEDROOM: 'unit',
  BED: 'subunit'
};

export const PROPERTY_RENT_TYPE = {
  PROPERTY: 'property',
  UNIT: 'unit',
  SUBUNIT: 'subunit'
};
